import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { components } from '@blaze-cms/react-page-builder';
import InspectionCopyForm from './InspectionCopyForm';
import { getIcMessage } from './helpers';

const InspectionCopyModal = ({
  hideModal,
  productData,
  inspectionCopyData,
  blazeAuthToken,
  successMessage,
  exceededPrintLimitMessage,
  ...props
}) => {
  const { textblock: TextBlock } = components;
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside({ target }) {
      const shouldHideFlyOut = wrapperRef.current && !wrapperRef.current.contains(target);
      if (shouldHideFlyOut) hideModal();
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [hideModal, wrapperRef]);

  const { showForm, message } = getIcMessage(inspectionCopyData, props, blazeAuthToken);

  return (
    <div className="kp-inspection-copy-request__modal-overlay">
      <div className="kp-inspection-copy-request__modal-overlay__modal" ref={wrapperRef}>
        <div
          className="kp-inspection-copy-request__modal-overlay__modal__header"
          role="presentation"
          onClick={hideModal}>
          <i className="fas fa-close" />
        </div>
        {!showForm && (
          <div className="info-message">
            <TextBlock html={message} />
          </div>
        )}
        {showForm && (
          <div className="modal__header">
            <h2 className="page-heading page-heading--modal">Inspection copy</h2>
          </div>
        )}
        {showForm && (
          <div className="kp-inspection-copy-request__modal-overlay__modal__content">
            <InspectionCopyForm
              inspectionCopyData={inspectionCopyData}
              blazeId={productData.blazeId}
              blazeAuthToken={blazeAuthToken}
              successMessage={successMessage}
              exceededPrintLimitMessage={exceededPrintLimitMessage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

InspectionCopyModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  productData: PropTypes.object.isRequired,
  inspectionCopyData: PropTypes.object.isRequired,
  blazeAuthToken: PropTypes.string,
  successMessage: PropTypes.string,
  restricedLoggedOutMessage: PropTypes.string,
  restricedLoggedInMessage: PropTypes.string,
  exceededPrintLimitMessage: PropTypes.string,
  alreadyRequestedMessage: PropTypes.string
};

InspectionCopyModal.defaultProps = {
  blazeAuthToken: '',
  successMessage: '',
  restricedLoggedOutMessage: '',
  restricedLoggedInMessage: '',
  exceededPrintLimitMessage: '',
  alreadyRequestedMessage: ''
};

export default InspectionCopyModal;
